<template>
  <div class="inner">

    <nav class="breadcrumb is-small has-dot-separator">
      <ul>
        <li>
          <b-icon
            icon="home"
            size="is-small"
          />
        </li>
        <li
          v-if="portefeuille"
          class="is-active"
        ><a href="#">
          {{ portefeuille.name }}
        </a></li>
        <li
          v-if="site"
          class="is-active"
        ><a href="#">
          {{ site.name }}
        </a></li>
        <li
          v-if="bien"
          class="is-active"
        ><a href="#">
          {{ bien.name }}
        </a></li>
        <li class="is-active"><a href="#">
          {{ activeTab === 0 ? 'Documents' : 'Questions' }}
        </a></li>
      </ul>
    </nav>

    <PortefeuilleDocumentApercu
      v-if="activeTab === 0 && ($route.query.invdoc || $route.query.dl)  "
    />

    <b-tabs
      v-model="activeTab"
      :animated="false"
    >
      <b-tab-item>
        <template slot="header">
          <b-icon icon="folder" size="is-small"/>
          Documents
        </template>

        <PortefeuilleDocuments/>

      </b-tab-item>
      <b-tab-item :visible="allowQuestions">
        <template slot="header">
          <b-icon icon="question-circle" size="is-small"/>
          Questions
        </template>

        <PortefeuilleQuestions/>

      </b-tab-item>
      <b-tab-item>
        <template slot="header">
          <b-icon icon="envelope" size="is-small" pack="far"/>
          Notifications
        </template>

        <PortefeuilleNotifications/>

      </b-tab-item>
    </b-tabs>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import PortefeuilleDocumentApercu from '@/components/Portefeuille/DocumentApercu'
import PortefeuilleDocuments from '@/components/Portefeuille/Documents'
import PortefeuilleNotifications from '@/components/Portefeuille/Notifications'
import PortefeuilleQuestions from '@/components/Portefeuille/Questions'

export default {
  components: {
    PortefeuilleDocumentApercu,
    PortefeuilleDocuments,
    PortefeuilleNotifications,
    PortefeuilleQuestions,
  },
  data () {
    let activeTab = 0
    if (this.$route.params.tab === 'questions') activeTab = 1
    else if (this.$route.params.tab === 'notifications') activeTab = 2
    return {
      activeTab,
    }
  },
  computed: {
    ...mapState({
      biens: state => state.inv.biens,
    }),
    ...mapGetters({
      allowQuestions: 'inv/allowQuestions',
    }),
    portefeuille () {
      if (!this.$route.params.portefeuille) return
      const value = this.biens.find(i => i.portefeuille === +this.$route.params.portefeuille)
      return value ? {
        id: value.portefeuille,
        name: value.portefeuilleName,
      } : null
    },
    site () {
      if (!this.$route.params.site) return
      const value = this.biens.find(i => i.site === +this.$route.params.site)
      return value ? {
        id: value.site,
        name: value.siteName,
      } : null
    },
    bien () {
      if (!this.$route.params.bien || !this.site) return
      return _.find(this.biens, {
        id: +this.$route.params.bien,
        portefeuille: +this.$route.params.portefeuille,
      }) || null
    },
  },
  watch: {
    activeTab () {
      if (this.activeTab === 1) {
        this.$router.replace(`/portefeuille/${this.$route.params.portefeuille}/${this.$route.params.site}/${this.$route.params.bien}/questions`)
      } else if (this.activeTab === 2) {
        this.$router.replace(`/portefeuille/${this.$route.params.portefeuille}/${this.$route.params.site}/${this.$route.params.bien}/notifications`)
      } else {
        this.$router.replace(`/portefeuille/${this.$route.params.portefeuille}/${this.$route.params.site}/${this.$route.params.bien}`)
      }
    },
    portefeuille () {
      this.$store.commit('inv/PORTEFEUILLE_SETTINGS', this.$route.params.portefeuille)
    },
    bien () {
      this.$store.commit('inv/BIEN_CURRENT', this.$route.params.bien)
    },
  },
  created () {
    this.$store.commit('inv/BIEN_CURRENT', this.$route.params.bien)
    this.$store.commit('inv/PORTEFEUILLE_SETTINGS', this.$route.params.portefeuille)
  },
}
</script>

<style lang="scss" scoped>
.inner {
  padding: 1em 1em;
}
.b-tabs {
  background: #fff;
}
</style>
